import { hasWindow } from "@omni/utils/dom.utils";
import React, { useEffect } from "react";

type RenderAndHydrateHtmlProps = {
    innerHtml: string;
};

const RenderAndHydrateHtml = ({ innerHtml }: RenderAndHydrateHtmlProps) => {
    const containerRef = React.useRef<HTMLDivElement>(null);

    // biome-ignore lint/correctness/useExhaustiveDependencies: <TODO>
    useEffect(() => {
        const hydrator = hasWindow() ? window.hydrator : undefined;

        if (hydrator && containerRef?.current) {
            const reactElements =
                containerRef.current.querySelectorAll<HTMLDivElement>(
                    "div[data-cq-data-path]"
                );
            reactElements.forEach((reactElement) => {
                hydrator.rehydrateAEMComponent(reactElement.dataset.cqDataPath);
            });
        }
    }, [containerRef.current]);

    return (
        <div
            ref={containerRef}
            dangerouslySetInnerHTML={{
                __html: innerHtml
            }}
        />
    );
};

export { RenderAndHydrateHtml };
